import { useEffect, useState } from "react";
import {
  createFileRoute,
  useNavigate,
  Link
} from "@tanstack/react-router";
import { useAuth } from "@/providers/authProvider";
import { ServiceLogo } from "@/components/ui/iconsvg";
// import { FirebaseError } from "firebase/app";
// import { signInWithCustomToken } from "firebase/auth";
// import { firebaseAuth } from "@/providers/authProvider";
import { z } from "zod";
import LoginImage from "@/assets/login.png";
import { toast } from "react-toastify";
// import {signInWithEmailAndPassword, getAuth} from "firebase/auth"
import "./signin.scss";
import {queryClient} from "@/main";

const fallback = "/competitions" as const;
// const FUNCTIONS_BASE_URL = import.meta.env.VITE_FUNCTIONS_BASE_URL || 'https://asia-northeast1-cmp-pjt-dev.cloudfunctions.net'

const SignInComponent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false);
  const search = Route.useSearch();
  const navigate = useNavigate();

  const { isAuthenticated, logout, signInWithEmailPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("")
    setIsLoading(true);
    try {
      const success = await signInWithEmailPassword(email, password);
      if (success) {
        queryClient.invalidateQueries(); // キャッシュを無効化
        toast.success("サインインしました。", {
          position: "bottom-left",
        })

        setTimeout(() => {
          console.log("navigate to", search.redirect || fallback);
          navigate({ to: search.redirect || fallback });
        }, 100);
      } else {
        throw new Error("サインインに失敗しました。");
      }
    } catch (error) {
      setError("アカウント情報が一致しません")
      toast.error("サインインに失敗しました。", {
        position: "bottom-left",
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const signinState = () => {
      const idToken = localStorage.getItem("idToken");

      if (isAuthenticated && idToken) {
        navigate({ to: search.redirect || fallback });
        return
      }

      if (isAuthenticated){
        logout()
      }

      if (idToken) {
        localStorage.removeItem("idToken")
        localStorage.removeItem("refreshToken")
      }
    };
    signinState()
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className="w-screen h-screen grid grid-cols-2 overflow-hidden"
        style={{
          backgroundImage: `url(${LoginImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left",
        }}
      >
        <div className="flex items-center justify-center">
          <ServiceLogo width={328} height={80} />
        </div>
        <section className="flex items-center justify-center h-[90vh]">
          <div className="flex flex-col items-center bg-white border border-graycolor border-opacity-50 rounded-md px-6 py-12">
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 w-[320px]">
              <div className="relative">
                <label htmlFor="email" className={email ? "" : "preinput"}>
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="example@skillupai.com"
                  className="signin"
                  autoComplete="email"
                  disabled={isLoading}
                />

              </div>
              <div className="relative">
              <label
                  htmlFor="password"
                  className={password ? "" : "preinput"}
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="******"
                  className="signin"
                  autoComplete="current-password"
                  disabled={isLoading}
                />
              </div>
              <p className="w-full text-right text-[#7E7E7E] mb-4 text-sm"><Link to="/forget-password">パスワードをお忘れの方はこちら</Link></p>
              <div className="flex items-center justify-center">
                <button type="submit" className="w-full py-3" disabled={isLoading}>
                  {isLoading ? "ログイン中..." : "ログイン"}
                </button>
              </div>
              {error && (
                <p className="text-red-600 text-sm mt-4 text-center">{error}</p>
              )}
            </form>
          </div>
        </section>
        <div className="col-start-2 flex items-center justify-end flex-col mb-12 text-sm text-gray-900">
          <ul className="linklist flex flex-wrap items-center justify-center mb-4">
            <li><a href="https://skillup-next.co.jp/" target="_blank" rel="noopener noreferrer">会社概要</a></li>
            <li><a href="https://share.hsforms.com/1ggRKeK26ShKTrjN_zGOEbw2mtef" target="_blank" rel="noopener noreferrer">お問い合わせ</a></li>
            <li><a href="https://skillup-next.co.jp/competition-terms-of-use/" target="_blank" rel="noopener noreferrer">利用規約</a></li>
            <li><a href="https://skillup-next.co.jp/privacy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a></li>
            <li><a href="https://skillup-next.co.jp/security-policy/" target="_blank" rel="noopener noreferrer">情報セキュリティーに関する方針</a></li>
          </ul>
          <p>&copy; SKILLUP NeXt, Ltd.</p>
        </div>
      </div>
    </>
  );
};

export const Route = createFileRoute("/signin")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  component: SignInComponent,
});